/**
 * Exports an array of objects to CSV and triggers a download.
 *
 * @param {Array} data - The array of objects to convert into CSV.
 * @param {string} filename - The desired name of the downloaded CSV file.
 */
const exportToCSV = (data, filename = "data.csv") => {
  if (!data || !data.length) {
    alert("No data available to export.");
    return;
  }

  // Create CSV headers from object keys
  const headers = Object.keys(data[0]);
  const csvRows = [];

  // Add the header row
  csvRows.push(headers.join(","));

  // Add the data rows
  data.forEach((row) => {
    // Map each header to the row's value.
    // Wrap in quotes to safeguard against commas or line breaks in the data.
    const values = headers.map((header) => {
      let value = row[header];

      // If it's an object or array, stringify it
      if (typeof value === "object" && value !== null) {
        try {
          value = JSON.stringify(value);
        } catch (err) {
          value = "[unserializable]";
        }
      }

      const escaped = String(value).replace(/"/g, '""');
      return `"${escaped}"`;
    });
    csvRows.push(values.join(","));
  });

  // Combine into a CSV string
  const csvString = csvRows.join("\n");

  // Create a Blob with the CSV data
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  // Create a temporary <a> element and trigger the download
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default exportToCSV;
